import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { Icon } from '../icons/Icon';
import { IconNames } from '../icons/Icons';
import styles from './Alert.module.scss';

export const Alert = ({
    children, className, onDismiss,
    type, icon = 'alert-circle-exclamation'
}: Props) => (
    <div className={classes(type, className)}>
        <Icon type={icon} className={styles.icon} />

        <div className={styles.text}>
            {children}
        </div>

        {onDismiss && (
            <div onClick={onDismiss} className={styles.dismiss}>
                <Icon type='general-ui-close' size='small' />
            </div>
        )}
    </div>
);

const classes = (type?: AlertTypes, className?: string) => {
    return classNames(styles.default, className, {
        [styles.success]: type === 'success',
        [styles.info]: type === 'info',
        [styles.warning]: type === 'warning',
        [styles.error]: type === 'error'
    });
};

type AlertTypes = 'success' | 'warning' | 'error' | 'info';

type Props = PropsWithChildren<{
    icon: IconNames;
    type?: AlertTypes;
    className?: string;
    onDismiss?: () => void;
}>;